import LoginBanner from './LoginBanner';
import LoginForm from './LoginForm';
import { useLogin } from '../../context/LoginContext';
import { useModal } from '../../context/ModalContext';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import { useEffect } from 'react';

const LoginPage = () => {
  const { setIsAuthenticated, isAuthenticated } = useLogin();
  const { showConfirm } = useModal();
  const navigate = useNavigate();
  const savedCreds = localStorage.getItem('matrixCreds');

  useEffect(() => {
    const reason = sessionStorage.getItem('logout_reason');

    if (reason === 'inactivity' && !isAuthenticated) {
      showConfirm(
        'Session timed out due to inactivity', // Modal title
        null, // No body text is needed
        () => {}, // Empty onConfirm, the modal will just close
        null, // No cancel button
        {
          confirmText: 'OK',
          type: 'error', // Use 'error' type to get the red button style
        },
      );
      // Clear the flag so the modal doesn't reappear on refresh
      sessionStorage.removeItem('logout_reason');
    }
  }, [showConfirm, isAuthenticated]);

  useEffect(() => {
    if (savedCreds && !isAuthenticated) {
      setIsAuthenticated(true);
    }
    if (isAuthenticated) {
      navigate('/conversations', { replace: true });
    }
  }, [isAuthenticated, setIsAuthenticated, navigate, savedCreds]);

  return (
    <div className="login-page">
      <div className="login-banner-container">
        <LoginBanner screenOverlay={false} />
      </div>
      <div className="login-form-container">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;